




















import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import { HsabExpenseResponse } from "@/shared/types";
import moment from "moment";
import { formatCurrency } from "@/shared/currency.js";

@Component({
  components: {}
})
export default class HsabExpenseCardRowPaymentDetail extends Vue {
  formatCurrency = formatCurrency;

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  get isNotionalReimbursement () {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.externalReimbursementId;
  }

  get isHsaReimbursement () {
    return this.expense
        && this.expense.reimbursement
        && this.expense.reimbursement.planName === "Health Savings Account";
  }

  get formattedFinalFilingDate () {
    if (this.expense && this.expense.reimbursement && this.expense.reimbursement.planYearFinalFilingDate) {
      return moment(this.expense.reimbursement.planYearFinalFilingDate).format("MMM DD, YYYY");
    }
    return "";
  }
}
